import { PAGE_TYPE_SEARCH_RESULTS } from 'shared/consts'
import {
  SERP_REFINED_QUERIES,
  SERP_REFINED_QUERIES_CLICK,
} from 'shared/experiments/consts'
import { getExperimentOnClient } from 'shared/experiments/utils/experiments'
import trackEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import store from 'shared/store'

export default () => {
  const { pageType } =
    store.getState()?.publicRuntimeConfig.pageProperties || {}
  const { isEnabled } = getExperimentOnClient(SERP_REFINED_QUERIES)

  const refinedQueriesLinks = document.querySelectorAll<HTMLElement>(
    '.o-SearchSuggestionLink'
  )

  if (!isEnabled) return

  if (pageType === PAGE_TYPE_SEARCH_RESULTS) {
    refinedQueriesLinks.forEach(singleQueryLink => {
      singleQueryLink?.addEventListener('click', element => {
        const target = <HTMLElement>element.target

        if (target.closest('.o-SearchSuggestionLink')) {
          trackEvent(SERP_REFINED_QUERIES_CLICK)
        }
      })
    })
  }
}
